import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewEmployee from "../view";
import { MODULE_EMPLOYEES } from "variables/modules";
import EditAssignedAssets from "./edit";
import ViewAssignedAssets from "./view";


const assignedAssetRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Assigned Assets",
		basePath: "employees/:employeeId/assigned-assets",
		mainComponent: <ViewEmployee />,
	    layout: "/console",	
	    subTitle:"Assigned Asset",
		viewComponent: <ViewAssignedAssets/>,
		createComponent: <EditAssignedAssets />,
		editComponent: <EditAssignedAssets />, 
		level:3,
		moduleId: MODULE_EMPLOYEES,
	})
]

export default assignedAssetRoutes;